import { USER_TYPES } from "@sajilni/config/constants";

const PRESERVED_AUTH_PARAMS = [
  "type",
  "eventId",
  "eventSlug",
  "callbackUrl",
  "goTo",
  "invitation",
  "token",
] as const;

export type AuthAudience = "organizer" | "attendee" | "participant";

export function resolveAuthAudience(type?: string | null): AuthAudience {
  if (!type) return "attendee";
  if (type === USER_TYPES.ADMIN || type === "admin") return "organizer";
  if (type === USER_TYPES.EXHIBITOR || type === USER_TYPES.SPONSOR) {
    return "participant";
  }
  if (type === "attendee" || type === USER_TYPES.USER) return "attendee";
  return "attendee";
}

export function signupTypeParam(audience: AuthAudience): string | undefined {
  if (audience === "organizer") return "admin";
  if (audience === "attendee") return "attendee";
  return undefined;
}

export function authAudienceTypeParam(audience: AuthAudience): string {
  return audience === "organizer" ? "admin" : "attendee";
}

export function getLoginTitleKey(
  audience: AuthAudience,
  type?: string
): string {
  if (audience === "organizer") return "titles.organizerLogin";
  if (audience === "attendee") return "titles.attendeeLogin";
  if (type) return `titles.${type}Login`;
  return "titles.organizerLogin";
}

export function getSignUpTitleKey(audience: AuthAudience): string {
  return audience === "organizer"
    ? "titles.organizerSignUp"
    : "titles.attendeeSignUp";
}

export function getPreservedAuthParams(
  searchParams: URLSearchParams | null
): Record<string, string | undefined> {
  const params: Record<string, string | undefined> = {};
  if (!searchParams) return params;

  for (const key of PRESERVED_AUTH_PARAMS) {
    if (key === "type") continue;
    params[key] = searchParams.get(key) ?? undefined;
  }
  return params;
}

export function buildAuthFlowHref(
  basePath: string,
  params: Record<string, string | undefined>
): string {
  const search = new URLSearchParams();

  for (const key of PRESERVED_AUTH_PARAMS) {
    const value = params[key];
    if (value && value !== "undefined") {
      search.set(key, value);
    }
  }

  const query = search.toString();
  return query ? `${basePath}?${query}` : basePath;
}
